import { css } from '@emotion/react';
import sickBabyBackground from '@assets/images/sick_baby_background.png';
import { White } from '@constants/color';

export const container = css({
  width: 1920,
  height: 1080,
  backgroundImage: `url(${sickBabyBackground})`,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center'
});

export const title = css({
  color: White.White10,
  fontSize: '48px',
  textAlign: 'center'
});

export const buttonContainer = css({
  display: 'flex',
  marginTop: '64px',
  columnGap: '24px',
  justifyContent: 'center'
});

export const button = css({
  width: '320px'
})
